export default "__VITE_ASSET__Cb0ugxh6__"